import { Tag } from "@chakra-ui/react";

export default function ChangeRequestStatusTag({ status }: { status: "pending" | "resolved" }) {
  switch (status) {
    case "resolved":
      return (
        <Tag colorScheme="green" display="inline-flex">
          Resolved
        </Tag>
      );

    case "pending":
      return (
        <Tag colorScheme="yellow" display="inline-flex">
          Pending
        </Tag>
      );
  }
}
